import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import {
  Container,
  ContainerFlexRow,
  ContainerFlexColumnStart,
  Title,
  Subtitle,
  CustomSubtitle,
  BrushStoke,
  Image,
  ContainerFlexColumn,
  Button,
} from './Utils/CustomClasses'

import { textTranslation, shouldTranslateTo } from '../utils/utils'
import { TestimonialsSection, AwardsSection } from './Homepage'

const Header = styled.div`
  background-color: #f2e8d8;
  flex-wrap: wrap;
  max-width: 100vw;

  background-image: url(${(props) => props.image});
  background-size: contain;
`

const HeaderContainerFlexColumnStart = styled(ContainerFlexColumnStart)`
  flex: 0 0 60%;
`

const HeaderImage = styled(Image)`
  @media screen and (max-width: 768px) {
    width: 90%;
    margin-left: -2px;
  }
`

const LineBreak = styled.div`
  background-color: #f2e8d8;
  img {
    width: 100vw;
  }
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  flex-wrap: wrap;
`

const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 20%;
  min-width: 200px;

  gap: 45px;

  padding: 40px 20px;
  border-radius: 15px;
  border: 1px solid #e8e8e8;

  background: #fff;
  box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.08);

  img {
    width: 80px;
  }
`

const CustomCardBox = styled(CardBox)`
  flex-basis: 30%;
  min-width: 250px;
  max-width: 310px;
`

const BigButton = styled(Button)`
  a {
    padding: 9px 100px;

    @media screen and (max-width: 600px) {
      padding: 9px 10px;
    }
  }
`

const BkContainerFlexColumn = styled(ContainerFlexColumn)`
  background-image: url(${(props) => props.image});
  background-size: cover;

  @media screen and (max-width: 768px) {
    background-size: contain;
  }
`

// import { Container } from './styles';

function Christmas() {
  const [pageTextHome, setPageTextHome] = React.useState([])
  const [pageText, setPageText] = React.useState([])

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('homepage', language, setPageTextHome)
    getPageText('christmas-home', language, setPageText)
  }, [])

  const Card = ({ image, text }) => {
    return (
      <CardBox>
        <img src={image} />
        <Title
          size="21px"
          sizemd="21px"
          sizesm="21px"
          center
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </CardBox>
    )
  }

  const CardCustom = ({ image, text }) => {
    return (
      <CustomCardBox>
        <img src={image} />
        <Title
          size="21px"
          sizemd="21px"
          sizesm="21px"
          center
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </CustomCardBox>
    )
  }

  return (
    <Container>
      {/* Heder */}
      <Header image="/images/christimass/snowflakes-bk-1.svg">
        <ContainerFlexRow
          gap="10px"
          gapMd="30px"
          padding="10vh 5vw 4vh 5vw"
          paddingSm="5vh 4vw 4vh 4vw"
        >
          <HeaderContainerFlexColumnStart
            gap="15px"
            gapMd="15px"
            padding="0"
            paddingSm="0"
          >
            <Title
              width="100%"
              size="50px"
              sizemd="70px"
              marginsm="0 0 0 8px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[0]}`,
              }}
            ></Title>
            <CustomSubtitle
              width="640px"
              size="27px"
              sizemd="27px"
              sizesm="17px"
              marginsm="0 0 0 8px"
              dangerouslySetInnerHTML={{
                __html: `${pageText[1]}`,
              }}
            ></CustomSubtitle>
            <BrushStoke>
              <CustomSubtitle
                width="640px"
                size="21px"
                sizemd="22px"
                sizesm="17px"
                marginsm="15px 0 15px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[2]}`,
                }}
              ></CustomSubtitle>
            </BrushStoke>
            <BigButton>
              <Link
                to="/signup"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[3]}`,
                }}
              ></Link>
            </BigButton>
          </HeaderContainerFlexColumnStart>

          <HeaderImage widthMd="80%" square>
            <img src="/images/christimass/header.svg" />
          </HeaderImage>
        </ContainerFlexRow>
      </Header>
      {/* Line */}
      <LineBreak>
        {window.innerWidth < 768 ? (
          <img src="/images/christimass/line-mobile.svg" />
        ) : (
          <img src="/images/christimass/line.svg" />
        )}
      </LineBreak>
      {/* Cards */}
      <BkContainerFlexColumn
        image={
          window.innerWidth < 768
            ? '/images/christimass/snowflakes-bk-3-mobile.svg'
            : '/images/christimass/snowflakes-bk-3.svg'
        }
        center
        padding="2vh 40px 12vh 5vw"
        paddingSm="2vh 8vw 6vh 8vw"
        background="#fff"
      >
        <Title
          smCenter
          size="50px"
          margin="0 0 30px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[4]}` }}
        ></Title>
        <CustomContainerFlexRow center gap="40px" gapMd="30px" rowMd>
          <Card image="/images/christimass/card-1.svg" text={pageText[5]} />
          <Card image="/images/christimass/card-2.svg" text={pageText[6]} />
          <Card image="/images/christimass/card-3.svg" text={pageText[7]} />
          <Card image="/images/christimass/card-4.svg" text={pageText[8]} />
        </CustomContainerFlexRow>
      </BkContainerFlexColumn>
      {/* Empower */}
      <ContainerFlexRow
        gray
        gap="50px"
        padding="10vh 7vw 10vh 7vw"
        paddingSm="4vh 7vw 6vh 7vw"
        paddingMd="7vh 40px 5vh 6vw"
        gapMd="20px"
      >
        <Image width="45vw" widthMd="40vw">
          <img src="/images/christimass/people.svg" />
        </Image>
        <ContainerFlexColumnStart gap="30px" center>
          <Title
            dangerouslySetInnerHTML={{
              __html: `${pageText[9]}`,
            }}
          ></Title>
          <Subtitle
            bold
            size="27px"
            sizemd="22px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[10]}`,
            }}
          ></Subtitle>
          <Subtitle
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[11]}`,
            }}
          ></Subtitle>
          <Subtitle
            bold
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[12]}`,
            }}
          ></Subtitle>
          <BigButton>
            <Link
              to="/signup"
              dangerouslySetInnerHTML={{
                __html: `${pageText[13]}`,
              }}
            ></Link>
          </BigButton>
        </ContainerFlexColumnStart>
      </ContainerFlexRow>
      {/* Cards 2 */}
      <BkContainerFlexColumn
        image={
          window.innerWidth < 768
            ? '/images/christimass/snowflakes-bk-4-mobile.svg'
            : '/images/christimass/snowflakes-bk-4.svg'
        }
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="6vh 5vw 6vh 5vw"
        background="#F2E8D8"
      >
        <Title
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[14]}` }}
        ></Title>
        <CustomContainerFlexRow center gap="40px" gapMd="30px" rowMd>
          <CardCustom image="/images/christimass/1.svg" text={pageText[15]} />
          <CardCustom image="/images/christimass/2.svg" text={pageText[16]} />
          <CardCustom image="/images/christimass/3.svg" text={pageText[17]} />
          <CardCustom image="/images/christimass/4.svg" text={pageText[18]} />
          <CardCustom image="/images/christimass/3.svg" text={pageText[19]} />
          <CardCustom image="/images/christimass/4.svg" text={pageText[20]} />
        </CustomContainerFlexRow>
      </BkContainerFlexColumn>
      {/* Giftee */}
      <BkContainerFlexColumn
        image={
          window.innerWidth < 768
            ? '/images/christimass/snowflakes-bk-5-mobile.svg'
            : '/images/christimass/snowflakes-bk-5.svg'
        }
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="6vh 5vw 6vh 5vw"
        background="#E1F5F7"
      >
        <Title
          center
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[21]}` }}
        ></Title>
        <CustomSubtitle
          center
          size="22px"
          sizemd="22px"
          sizesm="17px"
          margin="0 0 24px 0"
          marginsm="0 0 0 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[22]}`,
          }}
        ></CustomSubtitle>
        <CustomSubtitle
          center
          size="22px"
          sizemd="22px"
          sizesm="17px"
          margin="0 0 100px 0"
          marginsm="0 0 30px 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[23]}`,
          }}
        ></CustomSubtitle>
        <BigButton>
          <Link
            to="/signup"
            dangerouslySetInnerHTML={{
              __html: `${pageText[24]}`,
            }}
          ></Link>
        </BigButton>
      </BkContainerFlexColumn>
      {/* Enable */}
      <ContainerFlexRow
        background="#fff"
        gap="50px"
        padding="10vh 7vw 10vh 7vw"
        paddingSm="4vh 7vw 6vh 7vw"
        paddingMd="7vh 40px 5vh 6vw"
        gapMd="20px"
      >
        <ContainerFlexColumnStart gap="20px" center>
          <Title
            dangerouslySetInnerHTML={{
              __html: `${pageText[25]}`,
            }}
          ></Title>
          <CustomSubtitle
            size="24px"
            sizemd="24px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[26]}`,
            }}
          ></CustomSubtitle>
          <Subtitle
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[27]}`,
            }}
          ></Subtitle>
          <BigButton>
            <Link
              to="/search?seeking=homestays"
              dangerouslySetInnerHTML={{
                __html: `${pageText[28]}`,
              }}
            ></Link>
          </BigButton>
        </ContainerFlexColumnStart>
        <Image width="40vw" widthMd="40vw">
          <img src="/images/christimass/people-2.svg" />
        </Image>
      </ContainerFlexRow>
      {/* Elevate */}
      <BkContainerFlexColumn
        image={
          window.innerWidth < 768
            ? '/images/christimass/snowflakes-bk-6-mobile.svg'
            : '/images/christimass/snowflakes-bk-6.svg'
        }
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="12vh 5vw 6vh 5vw"
        background="#F8F9F9"
      >
        <Title
          center
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[29]}` }}
        ></Title>
        <BigButton>
          <Link
            to="/signup"
            dangerouslySetInnerHTML={{
              __html: `${pageText[30]}`,
            }}
          ></Link>
        </BigButton>
      </BkContainerFlexColumn>
      {/* Testimonials */}
      <TestimonialsSection pageText={pageTextHome} />
      {/* Awards */}
      <AwardsSection pageText={pageTextHome} />
      {/* Special Someone */}
      <BkContainerFlexColumn
        image={
          window.innerWidth < 768
            ? '/images/christimass/snowflakes-bk-7-mobile.svg'
            : '/images/christimass/snowflakes-bk-7.svg'
        }
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="12vh 5vw 6vh 5vw"
        background="#F2E8D8"
      >
        <Title
          center
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[31]}` }}
        ></Title>
        <BigButton>
          <Link
            to="/signup"
            dangerouslySetInnerHTML={{
              __html: `${pageText[32]}`,
            }}
          ></Link>
        </BigButton>
      </BkContainerFlexColumn>
    </Container>
  )
}

export default Christmas
